import { render, staticRenderFns } from "./ResignationFromCoursesSlidebar.vue?vue&type=template&id=6e5619b7"
import script from "./ResignationFromCoursesSlidebar.vue?vue&type=script&lang=js"
export * from "./ResignationFromCoursesSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports